import { Component, Injectable, inject, signal } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";

@Component({
    selector: "app-confirm-modal",
    standalone: true,
    templateUrl: "./confirm-modal.component.html"
})
export class ConfirmModalComponent {
    modal = inject(NgbActiveModal);

    readonly modalTitle = signal("");
    readonly modalBody = signal("");
    readonly confirmBtnText = signal("");
    readonly isConfirmDelete = signal(false);
}

@Injectable()
export class ConfirmModalService {
    private modal = inject(NgbModal);

    show(title: string, body: string, confirmBtnText: string, isConfirmDelete: boolean, size = "lg"): Observable<string> {
        const modalRef = this.modal.open(ConfirmModalComponent, { backdrop: "static", size: size });
        const component = modalRef.componentInstance as ConfirmModalComponent;
        component.modalTitle.set(title);
        component.modalBody.set(body);
        component.confirmBtnText.set(confirmBtnText);
        component.isConfirmDelete.set(isConfirmDelete);

        return modalRef.closed;
    }
}